import Slider from 'lib/ui/Slider'
import ColorPicker from 'lib/ui/ColorPicker'
import {Label} from 'lib/ui/typography'
import {
  NavButtonWithSize,
  DEFAULT_FONT_SIZE,
} from 'Event/Dashboard/components/NavButton'
import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import FontSelect from 'lib/FontSelect'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import {CAPS} from 'lib/ui/typography/FontStyleInput'

export default function Typography(props: {
  control: UseFormMethods['control']
  button: NavButtonWithSize
}) {
  const {control, button} = props

  return (
    <CollapsibleSection
      label="Typography"
      storageKey="sidebar.sidebarNavButtonConfig.styling.typography"
    >
      <Label>Font</Label>
      <Controller
        control={control}
        name="font"
        defaultValue={{
          family: button.font?.family || 'inherit',
          variants: button.font?.variants || [],
          styles: button.font?.styles || [CAPS],
        }}
        render={({value, onChange}) => (
          <FontSelect value={value} onChange={onChange} />
        )}
      />
      <Label>Font Size</Label>
      <Controller
        name="fontSize"
        defaultValue={button.fontSize || DEFAULT_FONT_SIZE}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={1}
            max={100}
            onChange={onChange}
            valueLabelDisplay="auto"
            value={value}
          />
        )}
      />
      <Controller
        name="textColor"
        control={control}
        defaultValue={button.textColor || ''}
        render={({value, onChange}) => (
          <ColorPicker label="Text Color" color={value} onPick={onChange} />
        )}
      />
      <Controller
        name="hoverTextColor"
        control={control}
        defaultValue={button.hoverTextColor || ''}
        render={({value, onChange}) => (
          <ColorPicker
            label="Text Hover Color"
            color={value}
            onPick={onChange}
            aria-label="text hover color"
          />
        )}
      />
    </CollapsibleSection>
  )
}
